import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from "../../../../app/core/auth/auth.service";
import { StorageService } from "../../../../app/core/services/storage.service";
import { CustomSpinnerService } from "../../../services/helpers/custom-spinner.service";
import { TranslatesService } from "../../../translates";
import { EventsService } from "../../../services/helpers/events.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { UserDto } from "../../../../app/api/models/user-dto";
import { StorageEnums } from "../../../models/enums";
import { UserProfileApiService } from 'src/app/api/services';

@Component({
  selector: 'vl-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
})
export class LanguageSwitcherComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() clazz: 'default' | 'sidebar' = 'default';
  @Input() hasUser = false;
  @Input() inputUser?: UserDto;
  public lang: string = 'en';
  private user: UserDto;
  isPublicView;

  private notifier: Subject<any> = new Subject<any>();


  constructor(private authService: AuthService,
              private storage: StorageService,
              private spinner: CustomSpinnerService,
              private profileUserService: UserProfileApiService,
              private translateService: TranslatesService,
              private eventsService: EventsService) {
    this.authService.$userAuth
        .pipe(
            takeUntil(this.notifier)
        ).subscribe(b => {
      this.isPublicView = !b;
    });
    this.eventsService.$profileObs.pipe(takeUntil(this.notifier)).subscribe(r => {
      this.user = r;
      this.changeLang(r.language);
      this.hasUser = true;
    });
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    setTimeout(async () => {
      this.lang = await this.storage.getItem(StorageEnums.LANG) || this.translateService.getCurrentLang();
    }, 0);;
  }

  ngOnDestroy(): void {
    this.notifier.next('');
    this.notifier.complete();
  }

  ionViewWillLeave() {
    this.notifier.next('');
    this.notifier.complete();
  }

  async changeLang(lang: string, needUserUpdateProfile = false) {
    if (lang != this.lang) {
      this.translateService.changeLang(lang);
      this.lang = lang;
      await this.storage.setItem(StorageEnums.LANG, lang);
      this.eventsService.updateNews();
      this.eventsService.langUpdate();
      const user = await this.storage.getItem(StorageEnums.USER_ID);
      if(needUserUpdateProfile && !this.isPublicView) {
        this.updateProfile(this.user || user, lang);
      }
    }
  }

  private updateProfile(user, lang) {
    this.spinner.show();
    user.language = lang;
    this.profileUserService.updateProfile(
        {body: user}
    ).pipe(takeUntil(this.notifier))
        .subscribe(async (r) => {
          this.eventsService.updateProfile(r);
          this.spinner.hide(500);
          await this.storage.setItem(StorageEnums.USER_ID, user);
        }, error => {
          this.spinner.hide(500);
        });
  }
}
